var blockquote_default = {
  "fontElementMap": "c9P0e",
  "quote": "s7qpX"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
